import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  QueryUpdateFlexibleBenefitComponentStatusMutationResponse,
  QueryUpdateFlexibleBenefitComponentStatusMutationVariables,
  UpdateFlexibleBenefitStatusInput,
} from '../types';

const updateFlexibleBenefitStatusMutation = gql`
  mutation UpdateFlexibleBenefitsComponentStatus($input: SetSalaryComponentStatusInput!) {
    payrollSetFlexibleBenefitsComponentStatus(input: $input) {
      is_active
      source
      code
      success
      message
    }
  }
`;

export const updateFlexibleBenefitStatus = (input: UpdateFlexibleBenefitStatusInput) => {
  return graphQLApi<
    QueryUpdateFlexibleBenefitComponentStatusMutationResponse,
    QueryUpdateFlexibleBenefitComponentStatusMutationVariables
  >({
    query: updateFlexibleBenefitStatusMutation,
    queryVariables: { input },
  });
};
